/**
 * Error types 
 */
enum ErrorType {
    InvalidFormat = 1,
    NoSites = 2,
}

export default ErrorType;
